import { useState } from "react";
import axios from "axios";
// import ConsoleHelper from "ConsoleHelper";

function useLogin() {
  const [loadingLogin, setLoadingLogin] = useState(false);

  const loginUser = async (loginData) => {
    // console.log(loginData);
    try {
      setLoadingLogin(true);
      const LOGIN_URL = process.env.REACT_APP_URL_API + "/auth/local";
      const login = await axios.post(LOGIN_URL, loginData);
      const BEARER_TOKEN = `Bearer ${login?.data?.jwt}`;
      const GET_ROLE_URL =
        process.env.REACT_APP_URL_API +
        "/users-permissions/roles/" +
        login?.data?.user?.role?.id;
      const roleResponse = await axios.get(GET_ROLE_URL, {
        headers: { Authorization: BEARER_TOKEN }
      });
      // console.log("--- Data Login ---");
      // console.log(login.data);
      // console.log(roleResponse.data);
      const data = await roleResponse.data;
      if (data) {
        const permissions = data.role.permissions.application.controllers;
        // console.log(permissions);
        return {
          jwt: login?.data?.jwt,
          id: login?.data?.user?.id,
          role: {
            id: login?.data?.user?.role?.id,
            name: login?.data?.user?.role?.name
          },
          permissions,
          team: {
            id: login?.data?.user?.team?.id,
            name: login?.data?.user?.team?.name
          }
        };
      }
    } catch (e) {
      if (e?.response?.data?.statusCode >= 401) {
        return "error-server";
      }
      return "error";
    } finally {
      setLoadingLogin(false);
    }
  };

  return { loadingLogin, loginUser };
}

export default useLogin;
